export enum TypeBaseEnum {
  PERSON = 'PERSON',
  UNIT = 'UNIT',
}
